import React, { useState } from "react";
import { Link } from "react-router-dom";

export function DemoPage() {
  const [formData, setFormData] = useState({
    name: "",
    businessName: "",
    email: "",
    phone: "",
    industry: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Wire to backend /api/leads
    console.log("Demo request:", formData);
  };

  return (
    <main className="min-h-screen bg-gradient-to-br from-white via-purple-50 to-pink-50 text-slate-50 pt-16">
      <section className="mx-auto max-w-4xl px-4 pb-12 pt-20">
        <div className="text-center mb-12">
          <p className="mb-3 inline-flex rounded-full border border-slate-700/60 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-slate-700">
            📺 Book a Demo
          </p>
          <h1 className="text-4xl font-bold text-slate-900 md:text-5xl">See Calyro.ai in Action</h1>
          <p className="mt-3 text-lg text-slate-700">
            Schedule a personalized demo and discover how Calyro.ai can transform your business.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Left: Form */}
          <form onSubmit={handleSubmit} className="rounded-2xl border border-slate-200 bg-white/80 p-8 shadow-xl">
            <div className="space-y-4">
              <label className="block text-sm">
                <span className="text-slate-200 font-medium">Full Name *</span>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="John Doe"
                  className="mt-1 w-full rounded-lg border border-slate-700 bg-gradient-to-br from-white via-purple-50 to-pink-50 px-4 py-2.5 text-sm text-slate-900 placeholder:text-slate-500 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20"
                  required
                />
              </label>
              <label className="block text-sm">
                <span className="text-slate-200 font-medium">Business Name *</span>
                <input
                  type="text"
                  name="businessName"
                  value={formData.businessName}
                  onChange={handleChange}
                  placeholder="Bright Smile Dental"
                  className="mt-1 w-full rounded-lg border border-slate-700 bg-gradient-to-br from-white via-purple-50 to-pink-50 px-4 py-2.5 text-sm text-slate-900 placeholder:text-slate-500 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20"
                  required
                />
              </label>
              <label className="block text-sm">
                <span className="text-slate-200 font-medium">Email *</span>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="you@example.com"
                  className="mt-1 w-full rounded-lg border border-slate-700 bg-gradient-to-br from-white via-purple-50 to-pink-50 px-4 py-2.5 text-sm text-slate-900 placeholder:text-slate-500 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20"
                  required
                />
              </label>
              <label className="block text-sm">
                <span className="text-slate-200 font-medium">Phone Number *</span>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="(555) 123-4567"
                  className="mt-1 w-full rounded-lg border border-slate-700 bg-gradient-to-br from-white via-purple-50 to-pink-50 px-4 py-2.5 text-sm text-slate-900 placeholder:text-slate-500 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20"
                  required
                />
              </label>
              <label className="block text-sm">
                <span className="text-slate-200 font-medium">Industry *</span>
                <select
                  name="industry"
                  value={formData.industry}
                  onChange={handleChange}
                  className="mt-1 w-full rounded-lg border border-slate-700 bg-gradient-to-br from-white via-purple-50 to-pink-50 px-4 py-2.5 text-sm text-slate-900 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20"
                  required
                >
                  <option value="">Select your industry</option>
                  <option value="dental">Dental Clinics</option>
                  <option value="medspa">Med Spas</option>
                  <option value="salon">Hair & Beauty Salons</option>
                  <option value="vet">Veterinary Clinics</option>
                  <option value="chiro">Chiropractors</option>
                  <option value="auto">Auto Repair</option>
                  <option value="other">Other</option>
                </select>
              </label>
              <label className="block text-sm">
                <span className="text-slate-200 font-medium">Message (Optional)</span>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your business and what you're looking for..."
                  rows="3"
                  className="mt-1 w-full rounded-lg border border-slate-700 bg-gradient-to-br from-white via-purple-50 to-pink-50 px-4 py-2.5 text-sm text-slate-900 placeholder:text-slate-500 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400/20"
                />
              </label>
            </div>

            <button
              type="submit"
              className="mt-6 w-full rounded-full bg-amber-400 px-4 py-3 text-sm font-semibold text-slate-950 hover:bg-amber-300 transition shadow-lg"
            >
              Request Demo
            </button>

            <p className="mt-4 text-xs text-center text-slate-600">
              We'll get back to you within 24 hours to schedule your personalized demo.
            </p>
          </form>

          {/* Right: Benefits */}
          <div className="space-y-6">
            <div className="rounded-2xl border border-slate-200 bg-white/60 p-6">
              <h3 className="text-lg font-semibold text-slate-900 mb-3">What You'll See</h3>
              <ul className="space-y-3 text-sm text-slate-700">
                <li className="flex items-start gap-2">
                  <span className="text-emerald-400">✓</span>
                  <span>Live demonstration of AI handling real customer calls</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-emerald-400">✓</span>
                  <span>How to customize AI responses for your specific business</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-emerald-400">✓</span>
                  <span>Analytics dashboard and reporting features</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-emerald-400">✓</span>
                  <span>Integration with your existing tools (calendar, CRM)</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-emerald-400">✓</span>
                  <span>ROI calculation based on your current call volume</span>
                </li>
              </ul>
            </div>

            <div className="rounded-2xl border border-slate-200 bg-white/60 p-6">
              <h3 className="text-lg font-semibold text-slate-900 mb-3">Why Choose Calyro.ai?</h3>
              <ul className="space-y-3 text-sm text-slate-700">
                <li className="flex items-start gap-2">
                  <span>🚀</span>
                  <span><strong>24-48 hour setup</strong> - Custom-built for your business</span>
                </li>
                <li className="flex items-start gap-2">
                  <span>📊</span>
                  <span><strong>40% revenue increase</strong> - Average across all clients</span>
                </li>
                <li className="flex items-start gap-2">
                  <span>🔒</span>
                  <span><strong>HIPAA compliant</strong> - Enterprise-grade security</span>
                </li>
                <li className="flex items-start gap-2">
                  <span>❤️</span>
                  <span><strong>500+ happy clients</strong> - Trusted by leading businesses</span>
                </li>
              </ul>
            </div>

            <div className="rounded-2xl border border-indigo-800/50 bg-indigo-900/20 p-6">
              <p className="text-sm text-slate-700">
                <strong className="text-slate-900">Not ready for a demo?</strong><br/>
                Start your onboarding today. Setup fee applies to ensure quality configuration.
              </p>
              <Link
                to="/signup"
                className="mt-4 inline-block rounded-full bg-indigo-500 px-6 py-2.5 text-sm font-semibold text-slate-900 hover:bg-indigo-400"
              >
                Start My Setup
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}